export default __webpack_public_path__ + "static/media/logo07.4ee8d000.svg";